class DyperRdl {

    rdl_service_by_address = {};

    constructor(dyper) {
        this.dyper = dyper;
        if (this.dyper.customer) {
            // this.load_rdl();
        }
    }

    on_variant_select = async () => {
        if (this.dyper.productId == '7824240247034') {

            this.block_purchase();

        }

    }

    find_selling_plan = (productId, variantId, frequency, period) => {
        if (window.selling_plans[productId]) {
            if (window.selling_plans[productId][variantId].length > 0) {
                for (let y = 0; y < window.selling_plans[productId][variantId].length; y++) {
                    let plan = window.selling_plans[productId][variantId][y];
                    if (plan.frequency == frequency && plan.frequency_period == period) {
                        return plan.id;
                    }
                }
            }
        }
        return false;
    }

    add_redyper = async (sku) => {
        let variantFound = false;
        let rdlProductId = 7824240247034;
        let rdlProduct =  window.product_data[rdlProductId];
        for (let variantIndex in rdlProduct.variants) {
            let variant = rdlProduct.variants[variantIndex];
            this.dyper.log(sku + " " + variant.sku);
            if (variant.sku == sku) {
                variantFound = variant;
            }
        }
        if (variantFound === false) {
            return false;
        }

        let sellingPlan = this.find_selling_plan(rdlProductId, variantFound.id, 2, 2);
        if (sellingPlan === false) {
            return false;
        }
        const config = fetchConfig('javascript');

        await this.dyper.cart_helper.clear_cart();
        let items = [
            {
                "id": variantFound.id,
                "quantity": 1,
                "selling_plan": sellingPlan
            }
        ];
        let cart = {
            items: items
        };

        config.body = JSON.stringify(cart);

        let response = await fetch(`${routes.cart_add_url}`, config)
            .then(response => {
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        window.location.href = "/checkout";
    }

    block_purchase = (y = 0) => {

        if (this.dyper.productId == '7824240247034') {
            var ab = this.block_purchase;
            var atcs = document.getElementsByClassName("product-form__submit");
            for (var x = 0; x < atcs.length; x++) {
                atcs[x].setAttribute('disabled', '');
                atcs[x].disabled = true;
            }
            y ++;
            if (y < 5) {
                setTimeout(function(){
                    ab(y);
                }(ab,y), 100);

            }
        }
    }

    join_waitlist = async(email, coords) => {
        let url = '/api/redyper/local/notify-me';
        let data = {};
        data = {
            "Latitude": coords.lat,
            "Longitude": coords.long,
            "Email": email,
            "Interest": "redyper-local"
        };
        if (this.dyper.customer) {
            data.CustomerID = this.dyper.customer.id;
        }
        this.dyper.log(data);
        var utc = new Date().toJSON().slice(0,10).replace(/-/g,'-');
        var options = { hour12: false };
        var time = new Date().toLocaleTimeString('en-US', options); // 11:18:48 AM
        // for (var x = 0; x < this.dyper.customer.addresses.length; x ++) {
        //     var address = this.dyper.customer.addresses[x];
        var rdl = await this.dyper.commerce_request(url, data, 'POST')

        console.log(rdl);
        this.dyper.trigger_toast(false, "Successfully joined the REDYPER™ Local waitlist for your area.");

        // }
        this.dyper.log("Waitlist Initialized");
    }

    load_rdl = async (address = false, coords = false) => {
        let url = '/api/redyper/local/search';
        let data = {};
        if (address === false) {
            console.log(coords);
            data = {
                "Latitude": coords.lat,
                "Longitude": coords.long
            };
            if (this.dyper.customer) {
                data.CustomerID = this.dyper.customer.id;
            }
            url = '/api/redyper/local/search-geo';
        } else {
            data = {
                "street1": address.address,
                "street2": address.address2,
                "city": address.city,
                "country": address.country_code,
                "state": address.state_province_code,
                "postalCode": address.zip_postal_code
            }
        }
        let customer_id = (this.dyper.customer ? this.dyper.customer.id : null);
        data.customer = customer_id;
        this.dyper.log("REDYPER");
        this.dyper.log(data);
        var utc = new Date().toJSON().slice(0,10).replace(/-/g,'-');
        var options = { hour12: false };
        var time = new Date().toLocaleTimeString('en-US', options); // 11:18:48 AM
        // for (var x = 0; x < this.dyper.customer.addresses.length; x ++) {
        //     var address = this.dyper.customer.addresses[x];
            var rdl = await this.dyper.commerce_request(url, data, 'POST')
            if (rdl.status === 200 && rdl.body !== undefined && rdl.body.hasOwnProperty('service')) {
                this.dyper.log(rdl);
                if (address !== false) {
                    this.rdl_service_by_address[address.public_id] = rdl.body.service;
                }
                return rdl.body.service;
            } else {
                return false;
            }

        // }
        this.dyper.log("RDL Initialized");

    }

}
